import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volvobuspuneforaurangabadsightseeing() {



const cardData =
{
  keyword: 'Volvo Bus Pune for Aurangabad Sightseeing',
  heading: 'Sanavi Travels: Volvo Bus Pune for Aurangabad Sightseeing',
  headingDescription: 'Sanavi Travels offers premium Volvo bus services from Pune for Aurangabad sightseeing, designed for families, tourists, corporate groups, schools, and heritage travelers who want a safe, comfortable, and luxury group travel experience while exploring Aurangabad’s world-famous monuments.',

  top: 'Top Places to Explore in Aurangabad with Volvo Bus from Pune',

  topPlaces: [
    {
      title: 'Ajanta Caves – World Heritage Marvel',
      description: 'Ajanta Caves are globally celebrated for their ancient Buddhist murals, sculptures, and frescoes carved into rock cliffs overlooking the Waghora River. Traveling in a Volvo bus from Pune allows large groups to enjoy a relaxed overnight or early-morning journey with reclining seats, climate control, and smooth suspension. For school groups, families, and international tourists, the Volvo bus journey itself becomes part of the experience, offering rest, safety, and comfort before a full day of exploration. Group travel ensures synchronized entry, guided tours, and stress-free coordination without worrying about multiple vehicles, parking issues, or travel fatigue.'
    },
    {
      title: 'Ellora Caves & Kailasa Temple',
      description: 'Ellora Caves represent a rare coexistence of Buddhist, Hindu, and Jain monuments, highlighted by the awe-inspiring Kailasa Temple carved from a single rock. A Volvo bus is ideal for this long sightseeing schedule, allowing passengers to relax between sites. Corporate teams and heritage enthusiasts appreciate the quiet, air-suspended ride that keeps everyone refreshed even after hours of walking. The spacious luggage bays also make it convenient for carrying food supplies, camera equipment, and personal belongings during extended tours.'
    },
    {
      title: 'Bibi Ka Maqbara – The Mini Taj of Deccan',
      description: 'Often called the Mini Taj Mahal, Bibi Ka Maqbara is a must-visit attraction in Aurangabad. Volvo bus travel makes it easy for groups to reach the site comfortably after visiting Ajanta or Ellora. The calm interiors, wide windows, and smooth ride enhance sightseeing pleasure, especially for senior citizens and family travelers who value comfort and reduced travel stress.'
    },
    {
      title: 'Daulatabad (Devgiri) Fort',
      description: 'Daulatabad Fort is a masterpiece of medieval military architecture, requiring time, energy, and proper planning to explore. Traveling by Volvo bus ensures visitors arrive well-rested and hydrated, making the climb and exploration more enjoyable. Tour operators and educational institutions prefer Volvo buses for such physically demanding itineraries due to their reliability and passenger comfort.'
    },
    {
      title: 'Aurangabad City & Local Markets',
      description: 'Aurangabad’s local bazaars, handicraft centers, and cuisine spots add cultural depth to sightseeing tours. A Volvo bus enables easy movement between attractions, hotels, and markets without logistical delays. Groups can shop together, enjoy local food, and return comfortably to the bus without splitting up.'
    },
    {
      title: 'Corporate Heritage Offsites',
      description: 'Many companies organize heritage offsites and cultural learning trips to Aurangabad. Volvo buses support professional travel standards, punctual schedules, and executive-level comfort, making them ideal for leadership retreats, team outings, and client visits.'
    },
    {
      title: 'School & College Study Tours',
      description: 'Educational trips to Aurangabad require strict safety, discipline, and supervision. Volvo buses help teachers manage students effectively while offering safe seating, controlled travel, and reduced fatigue during long journeys.'
    },
    {
      title: 'Family & Group Vacations',
      description: 'Large families and friend groups traveling together enjoy the shared experience of Volvo bus journeys. Everyone stays together, conversations flow, and travel becomes part of the bonding experience.'
    },
    {
      title: 'Multi-Day Sightseeing Packages',
      description: 'Aurangabad sightseeing often spans two or more days. Volvo buses are designed for overnight and long-distance travel, offering consistent comfort throughout multi-day itineraries.'
    },
    {
      title: 'Eco-Friendly Group Travel',
      description: 'Choosing a single Volvo bus instead of multiple cars reduces fuel usage, traffic congestion, and environmental impact, supporting sustainable tourism.'
    }
  ],

  services: [
    {
      name: 'Volvo Bus Pune for Aurangabad Sightseeing',
      description: 'Sanavi Travels provides premium Volvo bus rentals from Pune to Aurangabad sightseeing destinations, ensuring luxury, safety, and smooth long-distance travel. Our Volvo buses feature reclining push-back seats, powerful air conditioning, air suspension, ample legroom, and large luggage compartments. This service is ideal for families, tourists, corporate teams, educational institutions, and large groups who want a high-end travel experience while visiting Ajanta, Ellora, Bibi Ka Maqbara, and other landmarks.'
    },
    {
      name: 'AC Volvo Bus Aurangabad Sightseeing',
      description: 'Fully air-conditioned Volvo buses maintain a comfortable interior temperature throughout the journey, crucial for summer travel and long sightseeing schedules.'
    },
    {
      name: 'Luxury Volvo Bus Hire Aurangabad Sightseeing',
      description: 'Luxury Volvo buses offer premium interiors, quiet cabins, and superior ride quality, suitable for VIP guests, corporate delegations, and international tourists.'
    },
    {
      name: '32 Seater Volvo Bus Aurangabad Sightseeing',
      description: '32 seater Volvo buses are ideal for medium-sized groups such as colleges, offices, and private tour groups seeking comfort and efficiency.'
    },
    {
      name: '35 Seater Volvo Bus Hire Aurangabad Sightseeing',
      description: '35 seater Volvo buses accommodate larger groups while maintaining high comfort standards and smooth travel performance.'
    },
    {
      name: 'Volvo Bus for Family Aurangabad Sightseeing',
      description: 'Family tours benefit from safe driving, comfortable seating, and enough space for elders, children, and luggage.'
    },
    {
      name: 'Volvo Bus for Corporate Aurangabad Sightseeing',
      description: 'Corporate Volvo bus services ensure professional travel planning, punctual schedules, and premium comfort for business groups.'
    },
    {
      name: 'Affordable Volvo Bus Rental Aurangabad Sightseeing',
      description: 'Despite being a luxury option, Sanavi Travels offers competitive and transparent pricing for Volvo bus rentals.'
    },
    {
      name: 'Best Volvo Bus Service Aurangabad Sightseeing',
      description: 'Our reputation is built on reliability, well-maintained buses, trained drivers, and excellent customer satisfaction.'
    },
    {
      name: 'Volvo Bus with Driver Aurangabad Sightseeing',
      description: 'All Volvo buses come with experienced drivers familiar with Pune–Aurangabad routes and sightseeing logistics.'
    },
    {
      name: 'Volvo Bus for Wedding Aurangabad Sightseeing',
      description: 'Destination wedding guest transport and family sightseeing arrangements are handled smoothly with Volvo buses.'
    },
    {
      name: 'Volvo Bus for Picnic Aurangabad Sightseeing',
      description: 'Picnic and leisure groups enjoy relaxed travel, onboard comfort, and organized group movement.'
    },
    {
      name: 'Volvo Bus for Group Aurangabad Sightseeing',
      description: 'Group tours become more enjoyable when everyone travels together in a single luxury vehicle.'
    },
    {
      name: 'Outstation Volvo Bus Aurangabad Sightseeing',
      description: 'Our Volvo buses are fully equipped for long outstation journeys, offering reliability and comfort throughout.'
    }
  ],

  tableData: [
    ['AC Volvo Bus', 'Luxury Volvo Bus'],
    ['32 Seater Volvo', '35 Seater Volvo'],
    ['Family Tour', 'Corporate Tour'],
    ['School Trip', 'Heritage Tour'],
    ['Affordable Plans', 'Premium Travel']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Premium Volvo Fleet',
      WhyChoosedescription: 'Modern Volvo buses with air suspension, push-back seats, and luxury interiors ensure a superior travel experience.'
    },
    {
      WhyChooseheading: 'Experienced Long-Route Drivers',
      WhyChoosedescription: 'Drivers trained for Pune–Aurangabad highways and sightseeing routes.'
    },
    {
      WhyChooseheading: 'Comfort for Long Journeys',
      WhyChoosedescription: 'Reduced fatigue and smoother rides even on extended travel schedules.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear and honest pricing with no hidden costs.'
    },
    {
      WhyChooseheading: 'Safe & Sanitized Buses',
      WhyChoosedescription: 'Strict safety checks and sanitation before every trip.'
    },
    {
      WhyChooseheading: 'Flexible Scheduling',
      WhyChoosedescription: 'Custom itineraries and pickup points available.'
    },
    {
      WhyChooseheading: 'Ideal for Heritage Tours',
      WhyChoosedescription: 'Designed specifically for cultural and heritage sightseeing.'
    },
    {
      WhyChooseheading: '24/7 Customer Support',
      WhyChoosedescription: 'Dedicated support from booking to trip completion.'
    }
  ]
};

const faqData = [
  { question: 'Do you provide Volvo buses from Pune to Aurangabad sightseeing?', answer: 'Yes, we provide luxury Volvo buses for Pune to Aurangabad sightseeing tours.' },
  { question: 'Are AC Volvo buses available?', answer: 'Yes, all Volvo buses are fully air-conditioned.' },
  { question: 'Is this suitable for school trips?', answer: 'Yes, Volvo buses are commonly used for educational and study tours.' },
  { question: 'Are drivers experienced?', answer: 'Yes, our drivers are trained for long-distance and sightseeing routes.' },
  { question: 'Can families book Volvo buses?', answer: 'Yes, family and private group bookings are welcome.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended during peak seasons.' },
  { question: 'Are buses sanitized?', answer: 'Yes, all buses are sanitized before every trip.' },
  { question: 'Is pricing transparent?', answer: 'Yes, we follow a transparent pricing policy.' },
  { question: 'Can pickup points be customized?', answer: 'Yes, pickup and drop points can be customized.' },
  { question: 'Is customer support available?', answer: 'Yes, 24/7 customer support is provided.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Kulkarni',
    feedback: 'We hired a Volvo bus from Pune for Aurangabad sightseeing with our extended family. The ride was extremely comfortable, the bus was clean, and the driver was very professional. It made our heritage trip truly memorable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rina Patwardhan',
    feedback: 'Our corporate team traveled to Aurangabad for a cultural offsite using Sanavi Travels’ Volvo bus. Excellent comfort, smooth ride, and perfect coordination throughout the journey.',
    rating: 5
  }
];


































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus Pune for Aurangabad Sightseeing - Sanavi Travels",
  "description": "Sanavi Travels offers Volvo bus services from Pune for Aurangabad sightseeing, including AC and Non-AC luxury Volvo buses in 32-seater and 35-seater configurations. Ideal for family tours, corporate travel, group sightseeing, weddings, picnics, and outstation journeys with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};








  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Volvo Bus Pune for Aurangabad Sightseeing | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Volvo buses from Pune for Aurangabad sightseeing with Sanavi Travels. AC & Non-AC luxury 32-seater and 35-seater Volvo buses for family tours, corporate travel, group sightseeing, weddings, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/303.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Volvobuspuneforaurangabadsightseeing;